module.exports = "/assets/data/dfa8e240ee43fdf611cf631fe74974e4-WD18.data.json";